import React from 'react';

import { breadcrumbs } from 'constants/translations';
import { Layout, Breadcrumbs } from 'components/common/dashboard';

const Engage = () => <Layout top={<Breadcrumbs path={breadcrumbs.MARKETING_AUTO_PILOT} />} />;

export default Engage;
